module.exports = ":host {\n    overflow: hidden;\n    display: block;\n    width: 100%;\n    position: relative;\n}"